var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M15.652,8.3a1.227,1.227,0,0,0,.29-1.228,1.155,1.155,0,0,0-.927-.815l-3.874-.588a.508.508,0,0,1-.381-.289L9.028,1.714a1.127,1.127,0,0,0-2.058,0L5.238,5.379a.509.509,0,0,1-.382.289L.983,6.255a1.155,1.155,0,0,0-.927.815A1.227,1.227,0,0,0,.346,8.3l2.8,2.852a.544.544,0,0,1,.146.468l-.661,4.027a1.209,1.209,0,0,0,.25.971,1.126,1.126,0,0,0,1.414.291l3.465-1.9a.5.5,0,0,1,.472,0l3.465,1.9a1.1,1.1,0,0,0,.534.139,1.132,1.132,0,0,0,.88-.431,1.209,1.209,0,0,0,.25-.971L12.7,11.618a.544.544,0,0,1,.146-.468Z",
    transform: "translate(0.001 -1.047)",
    fill: "#BFC5E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/StarGray.4811d23b.svg";
export { ForwardRef as ReactComponent };